function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.88 8.059H8.752v7.789H5.532v-7.79H4V5.322h1.532v-1.77C5.532 2.282 6.134.3 8.782.3l2.386.01v2.657H9.437c-.284 0-.684.142-.684.746v1.611h2.408l-.282 2.735z",
  fill: "#E1E8F2"
});

var SvgFacebookWhite = function SvgFacebookWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref);
};

export default SvgFacebookWhite;